<template>
    <v-col>
        <div class="wrap-head-detail">
            <div class="wrap-head-btn">
                <h1>{{ $t("administration.administration") }}</h1>
            </div>
        </div>

        <div class="wrap-detail">
            <v-form ref="form_add_tours_models">
                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12">
                            <h2>{{ $t("administration.settings") }}</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                    </v-row>
                    <div class="wrap-detail-content">
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="project_name"
                                    :label="$t('administration.project_name')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                />
                            </v-col>
                            <v-col/>
                            <v-col/>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <fieldset class="custom-input">
                                    <legend>{{ $t('administration.project_logo') }}</legend>

                                    <div class="image-picker" @click="onLogoClick">
                                        <img v-if="project_logo" :src="project_logo" alt="Logo"/>
                                        <span v-else>Cliquez ici pour sélectionner un logo</span>
                                    </div>
                                </fieldset>
                            </v-col>
                            <v-col cols="12" md="4">
                                <fieldset class="custom-input">
                                    <legend>{{ $t('administration.project_background') }}</legend>

                                    <div class="image-picker" @click="onBackgroundClick">
                                        <img v-if="project_background" :src="project_background" alt="Image de fond"/>
                                        <span v-else>Cliquez ici pour sélectionner une image de fond</span>
                                    </div>
                                </fieldset>
                            </v-col>
                            <v-col/>
                            <v-col/>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-menu max-width="300" :close-on-content-click="false">
                                    <template #activator="{ on }">
                                        <v-text-field
                                            v-model="primary_color"
                                            :label="$t('administration.primary_color')"
                                            class="color-picker-input"
                                            dense
                                            hide-details="auto"
                                            light
                                            outlined
                                            readonly
                                            v-on="on"
                                        >
                                            <template #prepend-inner>
                                                <div class="indicator" :style="{ backgroundColor: primary_color }"/>
                                            </template>
                                        </v-text-field>
                                    </template>

                                    <v-color-picker
                                        v-model="primary_color"
                                        mode="hexa"
                                        hide-mode-switch
                                    />
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-menu max-width="300" :close-on-content-click="false">
                                    <template #activator="{ on }">
                                        <v-text-field
                                            v-model="secondary_color"
                                            :label="$t('administration.secondary_color')"
                                            class="color-picker-input"
                                            dense
                                            hide-details="auto"
                                            light
                                            outlined
                                            readonly
                                            v-on="on"
                                        >
                                            <template #prepend-inner>
                                                <div class="indicator" :style="{ backgroundColor: secondary_color }"/>
                                            </template>
                                        </v-text-field>
                                    </template>

                                    <v-color-picker
                                        v-model="secondary_color"
                                        mode="hexa"
                                        hide-mode-switch
                                    />
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="id_label"
                                    :label="$t('administration.id_label')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="driver_label"
                                    :label="$t('administration.driver_label')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                />
                            </v-col>
                            <v-col/>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="boolean_label"
                                    :label="$t('administration.boolean_label')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="recovered_container"
                                    :label="$t('administration.recovered_container')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    v-model="scan_mod"
                                    :items="scan_mods"
                                    :label="$t('administration.scan_mod')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                ></v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-layout row align-center class="ma-radio">
                                    {{ $t('administration.delivery_first_popup_visible') }}
                                    <v-radio-group
                                        v-model="delivery_first_popup_visible"
                                        row
                                        class="radio-group">
                                        <v-radio
                                            label="Oui"
                                            value="Oui"
                                        ></v-radio>
                                        <v-radio
                                            label="Non"
                                            value="Non"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-layout>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="delivery_first_popup_title"
                                    :label="$t('administration.delivery_first_popup_title')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="delivery_first_popup_message"
                                    :label="$t('administration.delivery_first_popup_message')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-layout row align-center class="ma-radio">
                                    {{ $t('administration.delivery_second_popup_visible') }}
                                    <v-radio-group
                                        v-model="delivery_second_popup_visible"
                                        row
                                        class="radio-group">
                                        <v-radio
                                            label="Oui"
                                            value="Oui"
                                        ></v-radio>
                                        <v-radio
                                            label="Non"
                                            value="Non"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-layout>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="delivery_second_popup_title"
                                    :label="$t('administration.delivery_second_popup_title')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="delivery_second_popup_message"
                                    :label="$t('administration.delivery_second_popup_message')"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-layout row align-center class="ma-radio">
                                    {{ $t('administration.manage_customer_verification') }}
                                    <v-radio-group
                                        v-model="manage_customer_verification"
                                        row
                                        class="radio-group">
                                        <v-radio
                                            label="Oui"
                                            value="Oui"
                                        ></v-radio>
                                        <v-radio
                                            label="Non"
                                            value="Non"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-layout>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-layout row align-center class="ma-radio">
                                    {{ $t('administration.manage_vehicule_condition') }}
                                    <v-radio-group
                                        v-model="manage_vehicle_condition"
                                        row
                                        class="radio-group">
                                        <v-radio
                                            label="Oui"
                                            value="Oui"
                                        ></v-radio>
                                        <v-radio
                                            label="Non"
                                            value="Non"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-layout>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-layout row align-center class="ma-radio">
                                    {{ $t('administration.manage_customer_signature') }}
                                    <v-radio-group
                                        v-model="manage_customer_signature"
                                        row
                                        class="radio-group">
                                        <v-radio
                                            label="Oui"
                                            value="Oui"
                                        ></v-radio>
                                        <v-radio
                                            label="Non"
                                            value="Non"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-layout>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-layout row align-center class="ma-radio">
                                    {{ $t('administration.customer_photo_required') }}
                                    <v-radio-group
                                        v-model="customer_photo_required"
                                        row
                                        class="radio-group">
                                        <v-radio
                                            label="Oui"
                                            value="Oui"
                                        ></v-radio>
                                        <v-radio
                                            label="Non"
                                            value="Non"
                                        ></v-radio>
                                    </v-radio-group>
                                </v-layout>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="customer_photo_max"
                                    :label="$t('administration.customer_photo_max')"
                                    type="number"
                                    min="0"
                                    dense
                                    hide-details="auto"
                                    light
                                    outlined
                                />
                            </v-col>
                        </v-row>
                        <v-row class="text-right">
                            <v-col>
                                <v-btn
                                    class="btn"
                                    color="primary"
                                    :loading="savingConfig"
                                    @click="onSaveConfigClick"
                                >
                                    {{ $t("administration.save") }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-form>
        </div>

        <div class="wrap-detail d-none">
            <v-form ref="form_add_tours_models">
                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12">
                            <h2>{{ $t("administration.imports") }}</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-spacer/>
                        <v-btn class="btn px-15 py-7" color="primary" @click.stop="displayImportCustomersDialog">
                            {{ $t("administration.clients_import") }}
                        </v-btn>
                        <v-col cols="1"/>
                        <v-btn class="btn px-15 py-7" color="primary" @click.stop="displayImportToursDialog">
                            {{ $t("administration.tours_import") }}
                        </v-btn>
                        <v-spacer/>
                    </v-row>
                </div>
            </v-form>
        </div>

        <div class="wrap-detail">
            <v-form ref="form_add_tours_models">
                <div class="wrap-detail-element">
                    <v-row>
                        <v-col cols="12">
                            <h2>Réinitialisation</h2>
                            <hr class="trait secondary"/>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                        <v-spacer/>
                        <v-btn class="btn px-15 py-7" color="primary" @click.stop="launchResetToday">
                            Réinitialiser les tournées du jour
                        </v-btn>
                        <v-spacer/>
                    </v-row>
                </div>
            </v-form>
        </div>

        <v-dialog v-model="importCustomersDisplayed" max-width="600px">
            <v-sheet class="dialog" rounded>
                <div class="dialog-header">{{ $t("administration.clients_import") }}</div>
                <div class="dialog-content">
                    <v-form ref="form_new_driver">
                        <v-row>
                            <v-col>
                                <v-file-input
                                    v-model="fileCustomers"
                                    :label="$t('administration.file')"
                                    accept=".csv"
                                    counter
                                    show-size
                                />

                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn
                                            :disabled="fileCustomers === null"
                                            :loading="importing"
                                            color="primary"
                                            depressed
                                            @click="importCustomersFile"
                                            v-on="on"
                                        >
                                            {{ $t("administration.start_import") }}
                                        </v-btn>
                                    </template>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </v-sheet>
        </v-dialog>

        <v-dialog v-model="importToursDisplayed" max-width="600px">
            <v-sheet class="dialog" rounded>
                <div class="dialog-header">{{ $t("administration.tours_import") }}</div>
                <div class="dialog-content">
                    <v-form ref="form_new_driver">
                        <v-row>
                            <v-col>
                                <v-file-input
                                    v-model="fileTours"
                                    :label="$t('administration.file')"
                                    accept=".csv"
                                    counter
                                    show-size
                                />

                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn
                                            :disabled="fileTours === null"
                                            :loading="importing"
                                            color="primary"
                                            depressed
                                            @click="importToursFile"
                                            v-on="on"
                                        >
                                            {{ $t("administration.start_import") }}
                                        </v-btn>
                                    </template>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </v-sheet>
        </v-dialog>
    </v-col>

</template>

<script>
import Config from "../../config.singleton";
import {showSnackbar} from "../../functions";

export default {
    name: "Administrations",
    data() {
        return {
            project_name: null,
            project_logo: null,
            project_background: null,
            id_label: null,
            driver_label: null,
            boolean_label: null,
            primary_color: null,
            secondary_color: null,
            recovered_container: null,
            importing: false,
            importCustomersDisplayed: false,
            fileCustomers: null,
            importToursDisplayed: false,
            fileTours: null,
            scan_mod: null,
            scan_mods: ['Vanilla', 'Auto', 'Scan'],
            manage_customer_verification: null,
            manage_vehicle_condition: null,
            manage_customer_signature: null,
            customer_photo_max: null,
            customer_photo_required: null,
            delivery_first_popup_visible: null,
            delivery_first_popup_title: null,
            delivery_first_popup_message: null,
            delivery_second_popup_visible: null,
            delivery_second_popup_title: null,
            delivery_second_popup_message: null,
        };
    },

    computed: {
        savingConfig() {
            return Config.saving
        }
    },

    created() {
        this.parseConfig()
    },

    methods: {
        async getConfigs() {
            await Config.fetch(true)
            this.parseConfig()
        },

        parseConfig() {
            this.project_name = Config.project_name
            this.project_logo = Config.project_logo
            this.project_background = Config.project_background
            this.id_label = Config.id_label
            this.driver_label = Config.driver_label
            this.boolean_label = Config.boolean_label
            this.primary_color = Config.primary_color
            this.secondary_color = Config.secondary_color
            this.recovered_container = Config.recovered_container
            this.scan_mod = Config.scan_mod
            this.manage_customer_verification = Config.manage_customer_verification
            this.manage_vehicle_condition = Config.manage_vehicle_condition
            this.manage_customer_signature = Config.manage_customer_signature
            this.customer_photo_max = Config.customer_photo_max
            this.customer_photo_required = Config.customer_photo_required
            this.delivery_first_popup_visible = Config.delivery_first_popup_visible
            this.delivery_first_popup_title = Config.delivery_first_popup_title
            this.delivery_first_popup_message = Config.delivery_first_popup_message
            this.delivery_second_popup_visible = Config.delivery_second_popup_visible
            this.delivery_second_popup_title = Config.delivery_second_popup_title
            this.delivery_second_popup_message = Config.delivery_second_popup_message
        },

        async onLogoClick() {
            const [ file ] = await this.openFileDialog()
            if (!file) return
            this.project_logo = await this.encodeToBase64(file, {
                mimeType: 'image/png',
                maxWidth: 500,
            })
        },

        async onBackgroundClick() {
            const [ file ] = await this.openFileDialog()
            if (!file) return
            this.project_background = await this.encodeToBase64(file)
        },

        openFileDialog() {
            return new Promise((resolve, reject) => {
                const input = document.createElement('input')
                input.type = 'file'
                input.accept = 'image/*'
                input.multiple = false
                input.style.display = 'none'
                input.addEventListener('input', event => resolve(event?.target?.files ?? []))
                document.body.appendChild(input)
                input.click()
                document.body.removeChild(input)
            })
        },

        encodeToBase64(file, options = {}) {
            return new Promise((resolve, reject) => {
                if (!file) {
                    reject('Parameter file not set')
                    return;
                }
                const { mimeType = 'image/webp', maxWidth = null } = options
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                const reader = new FileReader()
                reader.onload = event => {
                    const img = new Image()
                    img.onload = () => {
                        try {
                            if (!!maxWidth && img.width > maxWidth) {
                                canvas.width = maxWidth
                                canvas.height = (maxWidth * img.height) / img.width
                            } else {
                                canvas.width = img.width
                                canvas.height = img.height
                            }
                            ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
                            const image = canvas.toDataURL(mimeType)
                            resolve(image)
                        } catch (e) {
                            reject(e)
                        }
                    }
                    img.onerror = error => reject(error)
                    img.src = event.target.result
                }
                reader.onerror = error => reject(error)
                reader.readAsDataURL(file)
            })
        },

        async createConfig() {
            try {
                const payload = {
                    project_name: this.project_name,
                    project_logo: this.project_logo,
                    project_background: this.project_background,
                    id_label: this.id_label,
                    driver_label: this.driver_label,
                    boolean_question: this.boolean_question,
                    primary_color: this.primary_color,
                    secondary_color: this.secondary_color,
                    recovered_container: this.recovered_container,
                    scan_mod: this.scan_mod,
                    manage_customer_verification: this.manage_customer_verification,
                    manage_vehicle_condition: this.manage_vehicle_condition,
                    manage_customer_signature: this.manage_customer_signature,
                    customer_photo_max: this.customer_photo_max,
                    customer_photo_required: this.customer_photo_required,
                    delivery_first_popup_visible: this.delivery_first_popup_visible,
                    delivery_first_popup_title: this.delivery_first_popup_title,
                    delivery_first_popup_message: this.delivery_first_popup_message,
                    delivery_second_popup_visible: this.delivery_second_popup_visible,
                    delivery_second_popup_title: this.delivery_second_popup_title,
                    delivery_second_popup_message: this.delivery_second_popup_message,
                }
                await Config.save(payload)
            } catch (e) {
                console.error(e)
            }
        },

        async onSaveConfigClick() {
            try {
                await this.createConfig()
                await this.getConfigs()
                showSnackbar('success', "Paramètres sauvegardés")
            } catch (e) {
                showSnackbar('error', 'Erreur lors de la sauvegarde des paramètres')
            }
        },

        displayImportCustomersDialog() {
            this.importCustomersDisplayed = true
        },
        closeImportCustomersDialog() {
            this.importCustomersDisplayed = false
        },
        async importCustomersFile() {
            this.importing = true
            try {
                const formData = new FormData()
                formData.append('file', this.fileCustomers)

                const options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }

                await this.axios.post('api/customers/import', formData, options)
                this.fileCustomers = null
                this.closeImportCustomersDialog()

                showSnackbar('success', this.$t('success.imported'))
            } catch (e) {

            } finally {
                this.importing = false
            }
        },
        displayImportToursDialog() {
            this.importToursDisplayed = true
        },
        closeImportToursDialog() {
            this.importToursDisplayed = false
        },
        async importToursFile() {
            this.importing = true
            try {
                const formData = new FormData()
                formData.append('file', this.fileTours)

                const options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }

                await this.axios.post('api/tours/import', formData, options)
                this.fileTours = null
                this.closeImportToursDialog()

                showSnackbar('success', this.$t('success.imported'))
            } catch (e) {

            } finally {
                this.importing = false
            }
        },
        async launchResetToday() {
            if (!confirm('Êtes-vous sûr de vouloir réinitialiser les tournées du jour ?')) return
            try {
                await this.axios.get('api/tours/reset-today')
                showSnackbar('success', 'Les tournées du jour ont été réinitialisées')
            } catch (e) {
                showSnackbar('error', 'Erreur lors de la réinitialisation des tournées du jour')
            }
        }
    }
}
</script>

<style scoped>
    .radio-group {
        margin-left: 30px;
    }
    .layout.ma-radio.row.align-center {
        margin-top: -10px !important;
        margin-left: 12px !important;
    }
</style>
